// stores
import useAuthenStore from '../stores/authen/authenStore'
import useAppFolderAndTabStore from '../stores/appFolderAndTab/appFolderAndTabStore'
import useCommentaryStore from '../stores/commentary/useCommentaryStore'
import useManageProjectStore from '../stores/manageProject/useManageProjectStore'

// constants
import { menuTab, customFolder } from '../constants/constants'
import constSubmittedStatus from '../constants/submittedStatus'
import constSubmittedType from '../constants/submittedType'
import constSubmittedStep from '../constants/submittedStep'
import constUserGroup from '../constants/userGroup'
import submittedType from '../constants/submittedType'
import submittedStatus from '../constants/submittedStatus'

// types
import { GetProjectResultType } from '../services/web/types/responseWebServiceTypes'

export enum FolderType {
    NewProject = 'ส่งพิจารณาครั้งแรก',
    EditAfterReview = 'แก้ไขหลังพิจารณา',
    CloseProject = 'ปิดโครงการ',
}

type TabListType = {
    nameTH: string
    id: number
    stepID: number
}

type GetTabFuncReturnType = {
    tabAdminList: TabListType[] | []
    tabResearcherList: TabListType[] | []
    tabChairmanList: TabListType[] | []
    tabCommitteeList: TabListType[] | []
}

const useCheckPermission = () => {
    const appFolderAndTabStore = useAppFolderAndTabStore()

    const authenStore = useAuthenStore()
    const { profile } = authenStore
    const commentaryStore = useCommentaryStore()
    const projectStore = useManageProjectStore()

    const irb = () => {
        return profile.irb
    }

    const isUserSystemAdmin = () => {
        //ผู้ดูแลระบบ
        const isPermission: boolean = profile.userGroupId === constUserGroup.systemAdmin
        return isPermission
    }

    const isUserAdmin = () => {
        //เจ้าหน้าที่
        const isPermission: boolean = profile.userGroupId === constUserGroup.officer
        return isPermission
    }
    const isUserChairman = () => {
        //ประธาน รอง เลขา และผู้ทบทวนเบื้องต้น
        const isPermission: boolean =
            profile.userGroupId === constUserGroup.president ||
            profile.userGroupId === constUserGroup.vicePresident ||
            profile.userGroupId === constUserGroup.secretary ||
            profile.userGroupId === constUserGroup.reviewer
        return isPermission
    }

    const isUserSecretary = () => {
        //เลขา
        const isPermission: boolean = profile.userGroupId === constUserGroup.secretary
        return isPermission
    }
    const isUserChairmanOnly = () => {
        //เลขา
        const isPermission: boolean =
            profile.userGroupId === constUserGroup.president || profile.userGroupId === constUserGroup.reviewer
        return isPermission
    }
    const isUserViceChairman = () => {
        //รองประธาน
        const isPermission: boolean = profile.userGroupId === constUserGroup.vicePresident
        return isPermission
    }

    const isUserCommittee = () => {
        //กรรมการ
        const isPermission: boolean = profile.userGroupId === constUserGroup.committee
        return isPermission
    }

    const isUserResearcher = () => {
        //นักวิจัย
        const isPermission: boolean = profile.userGroupId === constUserGroup.researcher
        return isPermission
    }

    const isCommitteeInProject = (lstCommitteeInProject: GetProjectResultType['committeeInfo']) => {
        let isValid = false
        const lstFilterCommittee = lstCommitteeInProject.filter((itm) => {
            return itm.userID === profile.userId
        })
        if (lstFilterCommittee.length > 0) {
            isValid = true
        }

        return isValid
    }

    const chkProjectStepViewMode = (projectData?: GetProjectResultType | null) => {
        const haveAboveSubmitted: boolean =
            projectData?.aroundSubmittedIDInfo.nextSubmittedID !== null &&
            projectData?.aroundSubmittedIDInfo.nextSubmittedID !== undefined
        const currentSelectTab = appFolderAndTabStore.tabSelected
        const currentFolderSelected = appFolderAndTabStore.folderSelected
        const stepID = projectData?.stepID
        const isProjectSuccess = projectData?.submittedStatusInfo?.value === 8
        const isNonconformance = projectData?.submitTypeInfo?.value === submittedType.nonconformance //รายงานไม่เป็นไปตามข้อกำหนด
        const terminateProjectByAdmin = projectData?.submitTypeInfo?.value === submittedType.terminateProjectByAdmin //ขอยุติโครงการ (โดยเจ้าหน้าที่)
        const isCloseProjectByAdmin = projectData?.submitTypeInfo?.value === submittedType.closeProjectByAdmin //รายงานไม่เป็นไปตามข้อกำหนด
        const isWithdrawProject = projectData?.submitTypeInfo?.value === submittedType.withdrawalProject
        const isWithdrawSubmitted = projectData?.submitTypeInfo?.value === submittedType.withdrawalSubmitted

        const projectCommitteeInfo = projectData?.committeeInfo ?? []
        const isWithdrawSubmitByAdmin = projectData?.isSubmitByAdmin && isWithdrawProject
        const isWaitResearcherEdit = projectData?.submittedStatusInfo?.value === submittedStatus.incorrectDocument

        let isViewMode = true

        switch (stepID) {
            case constSubmittedStep.submit:
                if (isUserResearcher()) {
                    isViewMode = false
                } else if (
                    isUserAdmin() &&
                    (isNonconformance ||
                        terminateProjectByAdmin ||
                        isCloseProjectByAdmin ||
                        isWithdrawProject ||
                        isWithdrawSubmitted)
                ) {
                    isViewMode = false
                }

                if (
                    isUserResearcher() &&
                    (terminateProjectByAdmin || isCloseProjectByAdmin || isNonconformance || isWithdrawSubmitByAdmin)
                ) {
                    isViewMode = true
                }

                break

            case constSubmittedStep.verifyDoc:
                if (isUserAdmin()) {
                    isViewMode = false
                }

                break

            case constSubmittedStep.specifyProjectType:
                if (isUserAdmin()) {
                    isViewMode = false
                } else if (isUserChairman()) {
                    isViewMode = false
                }
                break

            case constSubmittedStep.specifyAdditionalDoc:
                if (isUserAdmin()) {
                    isViewMode = false
                }

                break
            case constSubmittedStep.specifySchedule:
                if (isUserAdmin()) {
                    isViewMode = false
                }

                break
            case constSubmittedStep.commentary:
                if (isUserAdmin()) {
                    isViewMode = false
                } else if (isUserCommittee()) {
                    isViewMode = false
                } else if (isCommitteeInProject(projectCommitteeInfo)) {
                    isViewMode = false
                }

                break

            case constSubmittedStep.synthesis:
                if (isUserAdmin()) {
                    isViewMode = false
                } else if (isUserChairman()) {
                    isViewMode = false
                }
                break

            case constSubmittedStep.synthesisReview:
                if (isUserAdmin()) {
                    isViewMode = false
                }

                break
            case constSubmittedStep.certification:
                if (isUserAdmin()) {
                    isViewMode = false
                }

                break
            case constSubmittedStep.sign:
                //รองประธานจะไม่เห็น
                if (isUserAdmin()) {
                    isViewMode = false
                } else if (isUserChairman()) {
                    isViewMode = false
                    if (isUserViceChairman()) {
                        isViewMode = false
                    }
                }
                break
            case constSubmittedStep.memoMessage:
                //รองประธานจะไม่เห็น
                if (isUserAdmin()) {
                    isViewMode = false
                } else {
                    isViewMode = true
                }
                break
            case constSubmittedStep.confirmProjectWithdraw:
                if (isUserChairman() || isUserAdmin()) {
                    //แก็งผู้บริหาร หรือเจ้าหน้าที่สามารถกดปุ่มถอนเพิ่อรับทราบการถอนได้
                    isViewMode = false
                }
                break
            default:
                if (isUserResearcher()) {
                    isViewMode = false
                }
                break
        }

        if (stepID) {
            const findCommentary = projectData?.committeeCommentary?.find(
                (data) => data.committeeUserID === commentaryStore.selectedCommitteeID,
            )
            if (currentSelectTab?.stepID !== stepID) {
                isViewMode = true
            }

            if (
                stepID === constSubmittedStep.synthesis &&
                currentSelectTab?.stepID === constSubmittedStep.commentary &&
                findCommentary &&
                findCommentary.isDraftCommentary === true
            ) {
                isViewMode = false
            }

            const isCommentaryStep = currentSelectTab?.stepID === constSubmittedStep.commentary

            // เจ้าหน้าที่สามารถแก้ไขความคิดเห็นได้จนกว่าจะสังเคราะห์ความคิดเห็น (submittedStepId = 8).
            if (!isUserResearcher() && isCommentaryStep && stepID < constSubmittedStep.synthesisReview) {
                isViewMode = false
            }
        }

        if (isProjectSuccess) {
            //project ดำเนินการเสร็จสมบูรณ์แล้ว
            if (
                currentFolderSelected.id === customFolder.projectAmendment.id ||
                currentFolderSelected.id === customFolder.projectPhase.id ||
                currentFolderSelected.id === customFolder.projectRenewal.id ||
                currentFolderSelected.id === customFolder.raeProject.id ||
                currentFolderSelected.id === customFolder.terminateProject.id ||
                currentFolderSelected.id === customFolder.adverseEvents.id ||
                currentFolderSelected.id === customFolder.closeProject.id ||
                currentFolderSelected.id === customFolder.closeProjectByAdmin.id ||
                currentFolderSelected.id === customFolder.terminateProjectByAdmin.id ||
                currentFolderSelected.id === customFolder.withdrawProject.id ||
                currentFolderSelected.id === customFolder.withdrawSubmitted.id ||
                currentFolderSelected.id === customFolder.renewalAndAmendmentProject.id ||
                currentFolderSelected.id === customFolder.highRiskProjectProgressReport.id ||
                currentFolderSelected.id === customFolder.projectSiteVisit.id
            ) {
                //#1 กรณีที่เป็น custom folder จากฝั่ง front จะเข้า if นี้ก็คือ จะให้เป็นmode edit
                //#2 สาเหตุที่มาเช็คอยู่ภายใต้ if project ดำเนินการเสร็จสมบูรณ์แล้ว เนื่องจาก โครงการที่จะสามารถกดเพิ่ม custom folder ได้จะเป็นโครงการที่ต้องดำเนินการเสร็จสมบูรณืแล้ว
                isViewMode = false
            } else {
                isViewMode = true
            }
        }

        if (haveAboveSubmitted) {
            //ถ้ามี Folder อยู่ข้างบนตัวมัน มันจะกลายเป็น View Mode
            isViewMode = true
        }

        if (!isUserResearcher() && isWaitResearcherEdit) {
            //ถ้าสถานะเป็นรอผู้วิจัยแก้ไขเอกสาร
            isViewMode = false
        }

        return isViewMode
    }

    /**
     *
     * @param projectData
     * @param isIncludeOfficer แรกเริ่ม function จะเช็คเฉพาะ researcher
     * แต่บาง Flow researcher และ officer ใช้ component เดียวกันก็จะส่ง isIncludeOfficer = true มา
     * default as false
     * @returns
     */
    const checkCanUpdateDocument = (projectData?: GetProjectResultType | null, isIncludeOfficer = false) => {
        const hasNextSubmitted: boolean =
            projectData?.aroundSubmittedIDInfo.nextSubmittedID !== null &&
            projectData?.aroundSubmittedIDInfo.nextSubmittedID !== undefined
        const currentSelectTab = appFolderAndTabStore.tabSelected
        const stepID = Number(projectData?.stepID)

        let canUpdateProjectDocument = false

        const isDocumentStep = [constSubmittedStep.submit, constSubmittedStep.verifyDoc].includes(
            currentSelectTab?.stepID as constSubmittedStep,
        )

        // นักวิจัยสามารถแก้ไขเอกสารได้จนกว่าเจ้าหน้าที่จะตรวจสอบเอกสาร และ เป็นการยื่นล่าสุด
        if (
            isUserResearcher() &&
            isDocumentStep &&
            stepID < constSubmittedStep.specifyProjectType &&
            !hasNextSubmitted
        ) {
            canUpdateProjectDocument = true
        }

        // เจ้าหน้าที่สามารถแก้ไขได้ตลอดแต่เฉพาะเมื่อเรียก function ด้วย isIncludeOfficer = true
        if (isIncludeOfficer && !isUserResearcher() && isDocumentStep && !hasNextSubmitted) {
            canUpdateProjectDocument = true
        }

        return canUpdateProjectDocument
    }

    const isEditAfterReview = (submittedTypeID?: number) => {
        const isValid: boolean =
            submittedTypeID === constSubmittedType.editAfterReview ||
            submittedTypeID === constSubmittedType.exitAfterReview_AmendmentProject ||
            submittedTypeID === constSubmittedType.editAfterReview_nextPhaseProject ||
            submittedTypeID === constSubmittedType.editAfterReview_closeProject ||
            submittedTypeID === constSubmittedType.editAfterReview_terminateProject ||
            submittedTypeID === constSubmittedType.editAfterReview_renewalProject
        return isValid
    }

    const isCloseProject = (submittedTypeID?: number) => {
        const isValid: boolean = submittedTypeID === constSubmittedType.closeProject
        return isValid
    }

    const getTabListFunc = (selectedFolder?: any, projectData?: GetProjectResultType): GetTabFuncReturnType => {
        const stepID = projectData?.stepID
        const committeeInProject = projectData?.committeeInfo ?? []
        const submitTypeID = projectData?.submitTypeInfo?.value
        const submittedStatusID = projectData?.submittedStatusInfo?.value
        const isFlowApproveWithComment = projectData?.isFlowApproveWithComment ?? false
        const isProjectNotAboutPeople = projectData?.isNotAboutPeople ?? false
        let isNeedEditForm = projectData?.isNeedEditForm
        if (projectData?.isNeedEditForm === undefined || projectData?.isNeedEditForm === null) {
            isNeedEditForm = true
        }

        let tabAdminList: TabListType[] = []
        let tabResearcherList: TabListType[] = []
        let tabChairmanList: TabListType[] = []
        let tabCommitteeList: TabListType[] = []

        switch (stepID) {
            // *ยื่นเอกสาร, แก้ไขเอกสาร
            case constSubmittedStep.submit:
                tabAdminList = [menuTab.tab1]
                tabChairmanList = [menuTab.tab1Chairman]
                tabCommitteeList = [menuTab.tab1Committee]
                tabResearcherList = [menuTab.tab21]

                if (isFlowApproveWithComment) {
                    tabAdminList = [menuTab.tab26, menuTab.tab1]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman]
                    tabResearcherList = [menuTab.tab26, menuTab.tab21]
                    tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                } else if (isEditAfterReview(submitTypeID)) {
                    //แก้ไขหลังพิจารณา
                    tabResearcherList = [menuTab.tab26, menuTab.tab25]
                    tabAdminList = [menuTab.tab26, menuTab.tab1]
                    tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman]
                }

                if (submitTypeID === constSubmittedType.nonconformance) {
                    tabAdminList = [menuTab.tab21]
                }

                if (
                    submitTypeID === constSubmittedType.terminateProjectByAdmin ||
                    submitTypeID === constSubmittedType.closeProjectByAdmin
                ) {
                    tabAdminList = [menuTab.tab21]
                    tabResearcherList = []
                }

                if (submitTypeID === constSubmittedType.projectFilesUpload) {
                    tabAdminList = []
                    tabChairmanList = []
                    tabCommitteeList = []
                    tabResearcherList = []
                }
                // ข้อแก้ไขพร้อมต่ออายูโครงการ โดนส่งแก้ไขหลังพิจารณา ให้แสดง tab ผลการพิจารณา (ครั้งก่อน) ด้วย
                if (submitTypeID === constSubmittedType.editAfterReviewRenewalAndAmendmentProject) {
                    tabResearcherList = [menuTab.tab26, menuTab.tab21]
                }

                break
            // *ตรวจสอบเอกสาร
            case constSubmittedStep.verifyDoc:
                tabAdminList = [menuTab.tab1]
                tabChairmanList = [menuTab.tab1Chairman]
                tabCommitteeList = [menuTab.tab1Committee]
                tabResearcherList = [menuTab.tab21]

                if (isFlowApproveWithComment) {
                    tabAdminList = [menuTab.tab26, menuTab.tab1]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman]
                    tabResearcherList = [menuTab.tab26, menuTab.tab21]
                    tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                } else if (isEditAfterReview(submitTypeID)) {
                    //แก้ไขหลังพิจารณา
                    tabResearcherList = [menuTab.tab26, menuTab.tab21]
                    tabAdminList = [menuTab.tab26, menuTab.tab1]
                    tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman]
                }
                break
            // *กำหนดประเภทโครงการและกรรมการ
            case constSubmittedStep.specifyProjectType:
                tabAdminList = [menuTab.tab1, menuTab.tab2]
                tabChairmanList = [menuTab.tab1Chairman, menuTab.tab2Chairman]
                tabCommitteeList = [menuTab.tab1Committee]
                tabResearcherList = [menuTab.tab21]

                //@ts-ignore
                if (isEditAfterReview(submitTypeID)) {
                    //แก้ไขหลังพิจารณา
                    tabResearcherList = [menuTab.tab26, menuTab.tab21]
                    tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab2]
                    tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab2Chairman]
                }
                break
            // *กำหนดขอชุดโครงการที่ต้องส่ง
            case constSubmittedStep.specifyAdditionalDoc:
                tabAdminList = [menuTab.tab1, menuTab.tab2, menuTab.tab3]
                tabChairmanList = [menuTab.tab1Chairman, menuTab.tab2Chairman]
                tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee]
                tabResearcherList = [menuTab.tab21]

                //@ts-ignore
                if (isEditAfterReview(submitTypeID)) {
                    //แก้ไขหลังพิจารณา
                    tabResearcherList = [menuTab.tab26, menuTab.tab21]
                    tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab2, menuTab.tab3]
                    tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee, menuTab.tab2Commitee]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab2Chairman]
                }

                break
            // *ชุดโครงการครบถ้วนและกำหนดส่งความคิดเห็นของผู้ทบทวนหลัก
            case constSubmittedStep.specifySchedule:
                tabAdminList = [menuTab.tab1, menuTab.tab2, menuTab.tab3, menuTab.tab4, menuTab.tab5]
                tabChairmanList = [menuTab.tab1Chairman, menuTab.tab2Chairman]
                tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]
                tabResearcherList = [menuTab.tab21, menuTab.tab22]

                //@ts-ignore
                if (isEditAfterReview(submitTypeID)) {
                    //แก้ไขหลังพิจารณา
                    tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab2, menuTab.tab3, menuTab.tab4, menuTab.tab5]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab2Chairman]
                    tabCommitteeList = [
                        menuTab.tab26,
                        menuTab.tab1Committee,
                        menuTab.tab2Commitee,
                        menuTab.tab5Commitee,
                    ]
                    tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab22]
                }

                break
            // *บันทึกข้อคิดเห็นของกรรมการ
            case constSubmittedStep.commentary:
                tabAdminList = [menuTab.tab1, menuTab.tab2, menuTab.tab3, menuTab.tab4, menuTab.tab5]
                tabChairmanList = [menuTab.tab1Chairman, menuTab.tab2Chairman, menuTab.tab4Chairman]
                tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]
                tabResearcherList = [menuTab.tab21, menuTab.tab22]

                //@ts-ignore
                if (isEditAfterReview(submitTypeID)) {
                    //แก้ไขหลังพิจารณา
                    tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab22]
                    tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab2, menuTab.tab3, menuTab.tab4, menuTab.tab5]
                    tabCommitteeList = [
                        menuTab.tab26,
                        menuTab.tab1Committee,
                        menuTab.tab2Commitee,
                        menuTab.tab5Commitee,
                    ]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab2Chairman, menuTab.tab4Chairman]
                }

                //ประธานลองประธานเห็นหน้าบันทึกข้อคิดเห็นกรรมการได้เมื่อโดนกำหนดให้เป็นกรรมการ
                if (isCommitteeInProject(committeeInProject)) {
                    tabChairmanList = [...tabChairmanList, menuTab.tab5Commitee]
                }

                break

            case constSubmittedStep.synthesis:
                tabAdminList = [menuTab.tab1, menuTab.tab2, menuTab.tab3, menuTab.tab4, menuTab.tab5, menuTab.tab6]
                tabChairmanList = [
                    menuTab.tab1Chairman,
                    menuTab.tab2Chairman,
                    menuTab.tab4Chairman,
                    menuTab.tab5Chairman,
                    menuTab.tab6Chairman,
                ]
                tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]
                tabResearcherList = [menuTab.tab21, menuTab.tab22]
                //@ts-ignore
                if (isEditAfterReview(submitTypeID)) {
                    //แก้ไขหลังพิจารณา
                    tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab22]
                    tabAdminList = [
                        menuTab.tab26,
                        menuTab.tab1,
                        menuTab.tab2,
                        menuTab.tab3,
                        menuTab.tab4,
                        menuTab.tab5,
                        menuTab.tab6,
                    ]
                    tabCommitteeList = [
                        menuTab.tab26,
                        menuTab.tab1Committee,
                        menuTab.tab2Commitee,
                        menuTab.tab5Commitee,
                    ]
                    tabChairmanList = [
                        menuTab.tab26,
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab5Chairman,
                        menuTab.tab6Chairman,
                    ]
                }

                if (isCloseProject(submitTypeID) || submitTypeID === constSubmittedType.terminateProject) {
                    tabAdminList = [menuTab.tab1, menuTab.tab12]
                    tabChairmanList = [menuTab.tab1, menuTab.tab12]

                    tabCommitteeList = [menuTab.tab1Committee]
                    tabResearcherList = [menuTab.tab21]
                }

                break
            // *สังเคราะห์ข้อคิดเห็น
            case constSubmittedStep.synthesisReview:
                tabAdminList = [
                    menuTab.tab1,
                    menuTab.tab2,
                    menuTab.tab3,
                    menuTab.tab4,
                    menuTab.tab5,
                    menuTab.tab6,
                    menuTab.tab7,
                ]
                tabResearcherList = [menuTab.tab21, menuTab.tab22]
                tabChairmanList = [
                    menuTab.tab1Chairman,
                    menuTab.tab2Chairman,
                    menuTab.tab4Chairman,
                    menuTab.tab5Chairman,
                    menuTab.tab6Chairman,
                ]
                tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]
                if (submittedStatusID === constSubmittedStatus.complete) {
                    //Complete
                    tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23]
                }

                if (isFlowApproveWithComment) {
                    tabResearcherList = [menuTab.tab26, menuTab.tab21]
                    tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman]
                    tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                } else if (isEditAfterReview(submitTypeID)) {
                    tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab22]
                    //แก้ไขหลังพิจารณา
                    if (submittedStatusID === constSubmittedStatus.complete) {
                        //Complete
                        tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab22, menuTab.tab23]
                    }

                    tabAdminList = [
                        menuTab.tab26,
                        menuTab.tab1,
                        menuTab.tab2,
                        menuTab.tab3,
                        menuTab.tab4,
                        menuTab.tab5,
                        menuTab.tab6,
                        menuTab.tab7,
                    ]
                    tabCommitteeList = [
                        menuTab.tab26,
                        menuTab.tab1Committee,
                        menuTab.tab2Commitee,
                        menuTab.tab5Commitee,
                    ]
                    tabChairmanList = [
                        menuTab.tab26,
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab5Chairman,
                        menuTab.tab6Chairman,
                    ]
                } else if (isCloseProject(submitTypeID) || submitTypeID === constSubmittedType.terminateProject) {
                    tabAdminList = [menuTab.tab1, menuTab.tab12, menuTab.tab7]
                    tabChairmanList = [menuTab.tab1Chairman, menuTab.tab12]
                    tabCommitteeList = [menuTab.tab1Committee]
                    tabResearcherList = [menuTab.tab21, menuTab.tab23]
                }

                break
            // *ออกผลการพิจารณา
            case constSubmittedStep.certification:
                tabAdminList = [
                    menuTab.tab1,
                    menuTab.tab2,
                    menuTab.tab3,
                    menuTab.tab4,
                    menuTab.tab5,
                    menuTab.tab6,
                    menuTab.tab7,
                    menuTab.tab8,
                ]
                tabChairmanList = [
                    menuTab.tab1Chairman,
                    menuTab.tab2Chairman,
                    menuTab.tab4Chairman,
                    menuTab.tab5Chairman,
                    menuTab.tab6Chairman,
                ]
                tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]
                tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23]

                //@ts-ignore
                if (isFlowApproveWithComment) {
                    tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab8]
                    tabResearcherList = [menuTab.tab26, menuTab.tab21]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman]
                    tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                } else if (isEditAfterReview(submitTypeID)) {
                    //แก้ไขหลังพิจารณา
                    tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab22, menuTab.tab23]
                    tabAdminList = [
                        menuTab.tab26,
                        menuTab.tab1,
                        menuTab.tab2,
                        menuTab.tab3,
                        menuTab.tab4,
                        menuTab.tab5,
                        menuTab.tab6,
                        menuTab.tab7,
                        menuTab.tab8,
                    ]
                    tabCommitteeList = [
                        menuTab.tab26,
                        menuTab.tab1Committee,
                        menuTab.tab2Commitee,
                        menuTab.tab5Commitee,
                    ]
                    tabChairmanList = [
                        menuTab.tab26,
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab6Chairman,
                    ]
                }

                break
            // *ออกใบรับรอง
            case constSubmittedStep.sign:
                tabAdminList = [
                    menuTab.tab1,
                    menuTab.tab2,
                    menuTab.tab3,
                    menuTab.tab4,
                    menuTab.tab5,
                    menuTab.tab6,
                    menuTab.tab7,
                    menuTab.tab8,
                    menuTab.tab10,
                ]
                tabChairmanList = [
                    menuTab.tab1Chairman,
                    menuTab.tab2Chairman,
                    menuTab.tab4Chairman,
                    menuTab.tab5Chairman,
                    menuTab.tab6Chairman,
                    menuTab.tab9,
                ]
                tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]
                tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23]
                if (isUserViceChairman()) {
                    tabChairmanList = [
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab5Chairman,
                        menuTab.tab6Chairman,
                        menuTab.tab10,
                    ]
                }
                if (submittedStatusID === constSubmittedStatus.complete) {
                    //Complete
                    tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23, menuTab.tab24]
                }

                //@ts-ignore
                if (isFlowApproveWithComment) {
                    tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab8, menuTab.tab10]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab9]
                    tabResearcherList = [menuTab.tab26, menuTab.tab21]
                    tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]

                    if (isUserViceChairman()) {
                        tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab10]
                    }

                    if (submittedStatusID === constSubmittedStatus.complete) {
                        //Complete
                        tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab24]
                    }
                } else if (isEditAfterReview(submitTypeID)) {
                    //แก้ไขหลังพิจารณา

                    tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab22, menuTab.tab23]
                    tabAdminList = [
                        menuTab.tab26,
                        menuTab.tab1,
                        menuTab.tab2,
                        menuTab.tab3,
                        menuTab.tab4,
                        menuTab.tab5,
                        menuTab.tab6,
                        menuTab.tab7,
                        menuTab.tab8,
                        menuTab.tab10,
                    ]
                    tabCommitteeList = [
                        menuTab.tab26,
                        menuTab.tab1Committee,
                        menuTab.tab2Commitee,
                        menuTab.tab5Commitee,
                    ]
                    tabChairmanList = [
                        menuTab.tab26,
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab5Chairman,
                        menuTab.tab6Chairman,
                        menuTab.tab9,
                    ]
                    if (isUserViceChairman()) {
                        tabChairmanList = [
                            menuTab.tab26,
                            menuTab.tab1Chairman,
                            menuTab.tab2Chairman,
                            menuTab.tab4Chairman,
                            menuTab.tab5Chairman,
                            menuTab.tab6Chairman,
                            menuTab.tab10,
                        ]
                    }
                    if (submittedStatusID === constSubmittedStatus.complete) {
                        //Complete
                        tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab22, menuTab.tab23, menuTab.tab24]
                    }
                }

                if (isCloseProject(submitTypeID) || submitTypeID === constSubmittedType.terminateProject) {
                    //ลงนามใบบันทึกข้อความ
                    tabAdminList = [menuTab.tab1, menuTab.tab12, menuTab.tab7, menuTab.tab11, menuTab.tab10]
                    tabChairmanList = [menuTab.tab1Chairman, menuTab.tab12, menuTab.tab9]
                    tabCommitteeList = [menuTab.tab1Committee]
                    tabResearcherList = [menuTab.tab21, menuTab.tab23]

                    if (isUserChairmanOnly() || isUserViceChairman()) {
                        tabChairmanList = [menuTab.tab1Chairman, menuTab.tab12, menuTab.tab10]
                    }
                }

                if (
                    submitTypeID === constSubmittedType.editAfterReview_closeProject ||
                    submitTypeID === constSubmittedType.editAfterReview_terminateProject
                ) {
                    //ลงนามใบบันทึกข้อความ
                    tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab11, menuTab.tab10]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab9]
                    tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                    tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab23]

                    if (isUserChairmanOnly() || isUserViceChairman()) {
                        tabChairmanList = [menuTab.tab1Chairman, menuTab.tab1Chairman, menuTab.tab10]
                    }
                }

                if (submitTypeID === constSubmittedType.firstSubmitConsideration && isProjectNotAboutPeople) {
                    //ยื่นครั้งแรกไม่เกี่ยวกับคน
                    tabAdminList = [menuTab.tab1, menuTab.tab2, menuTab.tab11, menuTab.tab10]
                    tabChairmanList = [menuTab.tab1Chairman, menuTab.tab2Chairman, menuTab.tab11, menuTab.tab9]
                    tabCommitteeList = [menuTab.tab1Committee]
                    tabResearcherList = [menuTab.tab21, menuTab.tab23]

                    if (isUserChairmanOnly() || isUserViceChairman()) {
                        tabChairmanList = [menuTab.tab1Chairman, menuTab.tab2Chairman, menuTab.tab11, menuTab.tab10]
                    }
                }

                if (
                    submitTypeID === constSubmittedType.adverseEvent ||
                    submitTypeID === constSubmittedType.nonconformance
                ) {
                    //* ลงนามใบบันทึกข้อความ
                    //* รายงานเหตุการณ์ที่ไม่พึงประสงค์ รายงานที่ไม่เป็นไปตามข้อกำหนด
                    tabAdminList = [menuTab.tab1, menuTab.tab11, menuTab.tab10]
                    tabChairmanList = [menuTab.tab1, menuTab.tab11, menuTab.tab9]
                    tabCommitteeList = [menuTab.tab1Committee]
                    tabResearcherList = [menuTab.tab21, menuTab.tab23]

                    if (isUserChairmanOnly() || isUserViceChairman()) {
                        tabChairmanList = [menuTab.tab1, menuTab.tab11, menuTab.tab10]
                    }
                }

                if (submitTypeID === constSubmittedType.amendmentProject) {
                    //ขอแก้ไขโครงการหลังได้รับอนุมัติ
                    tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23]
                    tabChairmanList = [
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab5Chairman,
                        menuTab.tab6Chairman,
                        menuTab.tab9,
                    ]
                    tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]
                    if (isNeedEditForm) {
                        tabAdminList = [
                            menuTab.tab1,
                            menuTab.tab2,
                            menuTab.tab3,
                            menuTab.tab4,
                            menuTab.tab5,
                            menuTab.tab6,
                            menuTab.tab7,
                            menuTab.tab8,
                            menuTab.tab10,
                        ]
                    } else {
                        tabAdminList = [
                            menuTab.tab1,
                            menuTab.tab2,
                            menuTab.tab3,
                            menuTab.tab4,
                            menuTab.tab5,
                            menuTab.tab6,
                            menuTab.tab7,
                            menuTab.tab11,
                            menuTab.tab10,
                        ]

                        if (isUserChairmanOnly() || isUserViceChairman()) {
                            tabChairmanList = [
                                menuTab.tab1Chairman,
                                menuTab.tab2Chairman,
                                menuTab.tab4Chairman,
                                menuTab.tab5Chairman,
                                menuTab.tab6Chairman,
                                menuTab.tab10,
                            ]
                        }
                    }

                    if (submittedStatusID === constSubmittedStatus.complete) {
                        //Complete
                        tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23, menuTab.tab24]
                    }

                    if (isFlowApproveWithComment) {
                        tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab23]
                        tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab9]
                        tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                        if (isNeedEditForm) {
                            tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab8, menuTab.tab10]
                        } else {
                            tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab11, menuTab.tab10]
                        }

                        if (submittedStatusID === constSubmittedStatus.complete) {
                            tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23, menuTab.tab24]
                        }
                    }
                }

                if (submitTypeID === constSubmittedType.exitAfterReview_AmendmentProject) {
                    tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab22, menuTab.tab23]
                    tabChairmanList = [
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab5Chairman,
                        menuTab.tab6Chairman,
                        menuTab.tab9,
                    ]
                    tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]

                    if (isNeedEditForm) {
                        tabAdminList = [
                            menuTab.tab26,
                            menuTab.tab1,
                            menuTab.tab2,
                            menuTab.tab3,
                            menuTab.tab4,
                            menuTab.tab5,
                            menuTab.tab6,
                            menuTab.tab7,
                            menuTab.tab8,
                            menuTab.tab10,
                        ]
                        if (submittedStatusID === constSubmittedStatus.complete) {
                            //Complete
                            tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23, menuTab.tab24]
                        }
                    } else {
                        tabAdminList = [
                            menuTab.tab26,
                            menuTab.tab1,
                            menuTab.tab2,
                            menuTab.tab3,
                            menuTab.tab4,
                            menuTab.tab5,
                            menuTab.tab6,
                            menuTab.tab7,
                            menuTab.tab11,
                            menuTab.tab10,
                        ]

                        if (isUserChairmanOnly() || isUserViceChairman()) {
                            tabChairmanList = [
                                menuTab.tab1Chairman,
                                menuTab.tab2Chairman,
                                menuTab.tab4Chairman,
                                menuTab.tab5Chairman,
                                menuTab.tab6Chairman,
                                menuTab.tab10,
                            ]
                        }
                    }

                    if (isFlowApproveWithComment) {
                        tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab23]
                        tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab9]
                        tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]

                        if (isNeedEditForm) {
                            tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab8, menuTab.tab10]
                            if (submittedStatusID === constSubmittedStatus.complete) {
                                //Complete
                                tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23, menuTab.tab24]
                            }
                        } else {
                            tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab11, menuTab.tab10]
                        }
                    }
                }

                if (
                    submitTypeID === constSubmittedType.highRiskProjectProgressReport ||
                    submitTypeID === constSubmittedType.projectSiteVisit
                ) {
                    tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23]
                    tabChairmanList = [
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab5Chairman,
                        menuTab.tab6Chairman,
                        menuTab.tab9,
                    ]
                    tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]

                    tabAdminList = [
                        menuTab.tab1,
                        menuTab.tab2,
                        menuTab.tab3,
                        menuTab.tab4,
                        menuTab.tab5,
                        menuTab.tab6,
                        menuTab.tab7,
                        menuTab.tab11,
                        menuTab.tab10,
                    ]

                    if (isUserChairmanOnly() || isUserViceChairman()) {
                        tabChairmanList = [
                            menuTab.tab1Chairman,
                            menuTab.tab2Chairman,
                            menuTab.tab4Chairman,
                            menuTab.tab5Chairman,
                            menuTab.tab6Chairman,
                            menuTab.tab10,
                        ]
                    }

                    if (submittedStatusID === constSubmittedStatus.complete) {
                        //Complete
                        tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23]
                    }

                    if (isFlowApproveWithComment) {
                        tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab23]
                        tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab9]
                        tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]

                        tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab11, menuTab.tab10]

                        if (submittedStatusID === constSubmittedStatus.complete) {
                            tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23, menuTab.tab24]
                        }
                    }
                }

                if (
                    submitTypeID === constSubmittedType.editAfterReviewHighRiskProjectProgressReport ||
                    submitTypeID === constSubmittedType.editAfterReviewProjectSiteVisit
                ) {
                    tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab22, menuTab.tab23]
                    tabChairmanList = [
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab5Chairman,
                        menuTab.tab6Chairman,
                        menuTab.tab9,
                    ]
                    tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]

                    tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab11, menuTab.tab10]

                    if (isUserChairmanOnly() || isUserViceChairman()) {
                        tabChairmanList = [
                            menuTab.tab1Chairman,
                            menuTab.tab2Chairman,
                            menuTab.tab4Chairman,
                            menuTab.tab5Chairman,
                            menuTab.tab6Chairman,
                            menuTab.tab10,
                        ]
                    }

                    if (isFlowApproveWithComment) {
                        tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab23]
                        tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab9]
                        tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]

                        if (isNeedEditForm) {
                            tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab8, menuTab.tab10]
                            if (submittedStatusID === constSubmittedStatus.complete) {
                                //Complete
                                tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23, menuTab.tab24]
                            }
                        } else {
                            tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab11, menuTab.tab10]
                        }
                    }
                }

                if (submitTypeID === constSubmittedType.renewalAndAmendmentProject) {
                    tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23]
                    tabChairmanList = [
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab5Chairman,
                        menuTab.tab6Chairman,
                        menuTab.tab9,
                    ]
                    tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]
                    if (isNeedEditForm) {
                        tabAdminList = [
                            menuTab.tab1,
                            menuTab.tab2,
                            menuTab.tab3,
                            menuTab.tab4,
                            menuTab.tab5,
                            menuTab.tab6,
                            menuTab.tab7,
                            menuTab.tab8,
                            menuTab.tab10,
                        ]
                    } else {
                        tabAdminList = [
                            menuTab.tab1,
                            menuTab.tab2,
                            menuTab.tab3,
                            menuTab.tab4,
                            menuTab.tab5,
                            menuTab.tab6,
                            menuTab.tab7,
                            menuTab.tab11,
                            menuTab.tab10,
                        ]

                        if (isUserChairmanOnly() || isUserViceChairman()) {
                            tabChairmanList = [
                                menuTab.tab1Chairman,
                                menuTab.tab2Chairman,
                                menuTab.tab4Chairman,
                                menuTab.tab5Chairman,
                                menuTab.tab6Chairman,
                                menuTab.tab10,
                            ]
                        }
                    }

                    if (submittedStatusID === constSubmittedStatus.complete) {
                        //Complete
                        tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23, menuTab.tab24]
                    }

                    if (isFlowApproveWithComment) {
                        tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab23]
                        tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab9]
                        tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                        if (isNeedEditForm) {
                            tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab8, menuTab.tab10]
                            if (submittedStatusID === constSubmittedStatus.complete) {
                                //Complete
                                tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23, menuTab.tab24]
                            }
                        } else {
                            tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab11, menuTab.tab10]
                        }
                    }
                }

                if (submitTypeID === constSubmittedType.editAfterReviewRenewalAndAmendmentProject) {
                    tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab22, menuTab.tab23]
                    tabChairmanList = [
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab5Chairman,
                        menuTab.tab6Chairman,
                        menuTab.tab9,
                    ]
                    tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]

                    if (isNeedEditForm) {
                        tabAdminList = [
                            menuTab.tab26,
                            menuTab.tab1,
                            menuTab.tab2,
                            menuTab.tab3,
                            menuTab.tab4,
                            menuTab.tab5,
                            menuTab.tab6,
                            menuTab.tab7,
                            menuTab.tab8,
                            menuTab.tab10,
                        ]
                        if (submittedStatusID === constSubmittedStatus.complete) {
                            //Complete
                            tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23, menuTab.tab24]
                        }
                    } else {
                        tabAdminList = [
                            menuTab.tab26,
                            menuTab.tab1,
                            menuTab.tab2,
                            menuTab.tab3,
                            menuTab.tab4,
                            menuTab.tab5,
                            menuTab.tab6,
                            menuTab.tab7,
                            menuTab.tab11,
                            menuTab.tab10,
                        ]

                        if (isUserChairmanOnly() || isUserViceChairman()) {
                            tabChairmanList = [
                                menuTab.tab1Chairman,
                                menuTab.tab2Chairman,
                                menuTab.tab4Chairman,
                                menuTab.tab5Chairman,
                                menuTab.tab6Chairman,
                                menuTab.tab10,
                            ]
                        }
                    }

                    if (isFlowApproveWithComment) {
                        tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab23]
                        tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman, menuTab.tab9]
                        tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]

                        if (isNeedEditForm) {
                            tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab8, menuTab.tab10]
                            if (submittedStatusID === constSubmittedStatus.complete) {
                                //Complete
                                tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23, menuTab.tab24]
                            }
                        } else {
                            tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab11, menuTab.tab10]
                        }
                    }
                }

                //ยุติโครงการโดยเจ้าหน้าที่

                if (submitTypeID === constSubmittedType.terminateProjectByAdmin) {
                    //ลงนามใบบันทึกข้อความ
                    tabAdminList = [menuTab.tab21, menuTab.tab11, menuTab.tab10]
                    tabChairmanList = [menuTab.tab1Chairman, menuTab.tab9]
                    tabCommitteeList = [menuTab.tab1Committee, menuTab.tab23]
                    tabResearcherList = [menuTab.tab21, menuTab.tab23]

                    if (isUserChairmanOnly() || isUserViceChairman()) {
                        tabChairmanList = [menuTab.tab1Chairman, menuTab.tab10]
                    }
                }

                if (submitTypeID === constSubmittedType.closeProjectByAdmin) {
                    tabResearcherList = [menuTab.tab21, menuTab.tab23]
                    tabChairmanList = [menuTab.tab1Chairman, menuTab.tab9]
                    tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]
                    tabAdminList = [menuTab.tab21, menuTab.tab11, menuTab.tab10]

                    if (isUserChairmanOnly() || isUserViceChairman()) {
                        tabChairmanList = [menuTab.tab1Chairman, menuTab.tab10]
                    }
                }

                break
            // *ลงนาม
            case constSubmittedStep.memoMessage:
                tabAdminList = [menuTab.tab1Chairman, menuTab.tab11]
                tabChairmanList = [menuTab.tab1Chairman, menuTab.tab11]
                tabCommitteeList = [menuTab.tab1Committee]
                tabResearcherList = [menuTab.tab21, menuTab.tab23]

                if (submitTypeID === constSubmittedType.firstSubmitConsideration && isProjectNotAboutPeople) {
                    tabAdminList = [menuTab.tab1, menuTab.tab2, menuTab.tab11]
                    tabChairmanList = [menuTab.tab1Chairman, menuTab.tab2Chairman, menuTab.tab11]
                    tabCommitteeList = [menuTab.tab1Committee]
                    tabResearcherList = [menuTab.tab21, menuTab.tab23]
                }

                if (isCloseProject(submitTypeID) || submitTypeID === constSubmittedType.terminateProject) {
                    tabAdminList = [menuTab.tab1, menuTab.tab12, menuTab.tab7, menuTab.tab11]
                    tabChairmanList = [menuTab.tab1Chairman, menuTab.tab12]

                    tabCommitteeList = [menuTab.tab1Committee]
                    tabResearcherList = [menuTab.tab21, menuTab.tab23]
                }
                if (
                    submitTypeID === constSubmittedType.amendmentProject ||
                    submitTypeID === constSubmittedType.highRiskProjectProgressReport ||
                    submitTypeID === constSubmittedType.projectSiteVisit
                ) {
                    tabAdminList = [
                        menuTab.tab1,
                        menuTab.tab2,
                        menuTab.tab3,
                        menuTab.tab4,
                        menuTab.tab5,
                        menuTab.tab6,
                        menuTab.tab7,
                        menuTab.tab11,
                    ]
                    tabChairmanList = [
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab5Chairman,
                        menuTab.tab6Chairman,
                    ]
                    tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]
                    tabResearcherList = [menuTab.tab21, menuTab.tab22, menuTab.tab23]

                    if (isFlowApproveWithComment) {
                        tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab11]
                        tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab23]
                        tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman]
                        tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                    }
                }

                if (submitTypeID === constSubmittedType.exitAfterReview_AmendmentProject) {
                    tabAdminList = [
                        menuTab.tab26,
                        menuTab.tab1,
                        menuTab.tab2,
                        menuTab.tab3,
                        menuTab.tab4,
                        menuTab.tab5,
                        menuTab.tab6,
                        menuTab.tab7,
                        menuTab.tab11,
                    ]
                    tabChairmanList = [
                        menuTab.tab1Chairman,
                        menuTab.tab2Chairman,
                        menuTab.tab4Chairman,
                        menuTab.tab5Chairman,
                        menuTab.tab6Chairman,
                    ]
                    tabCommitteeList = [menuTab.tab1Committee, menuTab.tab2Commitee, menuTab.tab5Commitee]
                    tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab22, menuTab.tab23]

                    if (isFlowApproveWithComment) {
                        tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab7, menuTab.tab11]
                        tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab23]
                        tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman]
                        tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                    }
                }

                if (
                    submitTypeID === constSubmittedType.editAfterReview_closeProject ||
                    submitTypeID === constSubmittedType.editAfterReview_terminateProject ||
                    submitTypeID === constSubmittedType.editAfterReviewHighRiskProjectProgressReport ||
                    submitTypeID === constSubmittedType.editAfterReviewProjectSiteVisit
                ) {
                    tabAdminList = [menuTab.tab26, menuTab.tab1, menuTab.tab11]
                    tabChairmanList = [menuTab.tab26, menuTab.tab1Chairman]
                    tabCommitteeList = [menuTab.tab26, menuTab.tab1Committee]
                    tabResearcherList = [menuTab.tab26, menuTab.tab21, menuTab.tab23]
                }

                if (submitTypeID === constSubmittedType.terminateProjectByAdmin) {
                    tabAdminList = [menuTab.tab21, menuTab.tab11]
                    tabChairmanList = [menuTab.tab1Chairman]
                    tabCommitteeList = [menuTab.tab1Committee]
                    tabResearcherList = [menuTab.tab21, menuTab.tab23]
                }

                break
            // *บันทึกข้อความ
            case constSubmittedStep.confirmProjectWithdraw:
                tabAdminList = [menuTab.tab1, menuTab.tabConfirmProjectWithdraw]
                tabChairmanList = [menuTab.tab1, menuTab.tabConfirmProjectWithdraw]
                tabCommitteeList = [menuTab.tab21]
                tabResearcherList = [menuTab.tab21]

                if (projectData?.isSubmitByAdmin) {
                    tabAdminList = [menuTab.tab21, menuTab.tabConfirmProjectWithdraw]
                }

                break
            default:
                tabAdminList = []
                tabResearcherList = [menuTab.tab25]
                tabChairmanList = []
                tabCommitteeList = []
                if (submitTypeID === constSubmittedType.closeProject) {
                    tabAdminList = [menuTab.tab1]
                    tabChairmanList = [menuTab.tab1Chairman]
                    tabCommitteeList = [menuTab.tab1Committee]
                    tabResearcherList = [menuTab.tab21]
                }

                if (submitTypeID === constSubmittedType.terminateProjectByAdmin) {
                    tabAdminList = [menuTab.tab21]
                    tabChairmanList = []
                    tabCommitteeList = []
                    tabResearcherList = []
                }

                break
        }

        return { tabAdminList, tabResearcherList, tabChairmanList, tabCommitteeList }
    }

    const getTabRenderList = (
        projectStatus?: number | null,
        selectedFolder?: any,
        isHideTabRecord?: boolean,
        isDisApprove?: boolean,
        presidentMustSave?: boolean,
        projectData?: GetProjectResultType,
    ) => {
        let tabRenderList: any[] = []
        //** This Function Is Check UserGroup */
        if (isUserResearcher()) {
            //Researcher
            console.log('projectStatus', projectStatus)
            if (projectStatus) {
                const { tabResearcherList } = getTabListFunc(selectedFolder, projectData)
                tabRenderList = tabResearcherList
            } else {
                const projectStepID = projectData?.stepID
                if (projectStepID) {
                    const { tabResearcherList } = getTabListFunc(selectedFolder, projectData)
                    tabRenderList = tabResearcherList
                } else {
                    //NEW CREATE PROJECT
                    tabRenderList = [menuTab.tab21]
                }
            }
        } else if (isUserAdmin()) {
            //All ADMIN
            const { tabAdminList } = getTabListFunc(selectedFolder, projectData)
            tabRenderList = tabAdminList
            if (isHideTabRecord) {
                //กรณีเลือกประเภทโครงการเป็น Exempt => ไม่ต้อง Require กรรมการ => ถ้าไม่กำหนดกรรมการมา => ไม่ต้องกำหนดวันที่กรรมการลงความเห็น(disable) และ ไม่ต้องแสดง                                                                   tab บันทึกข้อคิดเห็นของกรรมการ
                tabRenderList = tabRenderList.filter((item) => {
                    return item.id !== menuTab.tab5.id
                })
            }

            if (isDisApprove) {
                tabRenderList = tabRenderList.filter((item) => {
                    return item.id < menuTab.tab8.id
                })
            }
        } else if (isUserChairman()) {
            const { tabChairmanList } = getTabListFunc(selectedFolder, projectData)
            tabRenderList = tabChairmanList
        } else if (isUserCommittee()) {
            //All กรรการ

            const { tabCommitteeList } = getTabListFunc(selectedFolder, projectData)
            tabRenderList = tabCommitteeList
            if (!presidentMustSave) {
                //กรณี login เข้ามาเป็นกรรมการแต่ไม่ได้เป็นกรรมการของโปรเจคนั้น ไม่ต้องแสดง tab บันทึกข้อคิดเห็นของกรรมการ
                tabRenderList = tabRenderList.filter((item) => {
                    return item.id !== menuTab.tab5.id
                })
            }
        }
        return { tabRenderList: tabRenderList }
    }

    const getFolderRenderList = (projectStatus?: number | null) => {
        let folderRenderList: any[] = []

        if (isUserResearcher()) {
            //Researcher
            if (projectStatus) {
                folderRenderList = [customFolder.createProject]
            } else {
                //new create project
                folderRenderList = [customFolder.createProject]
            }
        } else {
            //All Ofiicer
            folderRenderList = [customFolder.createProject]
        }

        return { folderRenderList: folderRenderList }
    }

    const chkShowUpdateDate = (projectData?: GetProjectResultType | null) => {
        const isViewMode = chkProjectStepViewMode(projectData)
        const isDraft = projectData?.isDraft
        let isShowUpdateDate = false

        if (isViewMode) {
            isShowUpdateDate = true
        } else {
            if (isDraft) {
                isShowUpdateDate = true
            } else {
                isShowUpdateDate = false
            }
        }

        return isShowUpdateDate
    }

    const chkDisplayBTNDeleteProject = (submittedTypeID: number) => {
        return [
            submittedType.firstSubmitConsideration,

            submittedType.nextPhaseProject,
            submittedType.renewalProject,
            submittedType.amendmentProject,
            submittedType.adverseEvent,
            submittedType.closeProject,
            submittedType.terminateProject,
            submittedType.withdrawalProject,
        ].some((id) => id == submittedTypeID)
    }

    const isAllowOfficerToEdit = (projectData: GetProjectResultType | null | undefined) => {
        const allowOfficer = [
            constSubmittedStep.submit,
            constSubmittedStep.verifyDoc,
            constSubmittedStep.specifyProjectType,
        ]
        return projectData?.stepID ? isUserAdmin() && allowOfficer.includes(projectData?.stepID) : false
    }

    const isAllowDefineDirector = (projectData: GetProjectResultType | null | undefined) => {
        return (
            (projectData?.stepID === constSubmittedStep.specifyAdditionalDoc ||
                projectData?.stepID === constSubmittedStep.specifySchedule ||
                projectData?.stepID === constSubmittedStep.commentary) &&
            !isUserCommittee()
        )
    }

    const checkSaveDraft = () => {
        const data = projectStore.projectData
        const currentSelectTab = appFolderAndTabStore.tabSelected
        return currentSelectTab?.stepID === data?.stepID
    }

    const checkDisabledProjectReviewer = (projectData: GetProjectResultType | null | undefined) => {
        const allowOfficer = [
            constSubmittedStep.specifyProjectType,
            constSubmittedStep.specifyAdditionalDoc,
            constSubmittedStep.specifySchedule,
            constSubmittedStep.commentary,
        ]
        return projectData?.stepID ? !allowOfficer.includes(projectData?.stepID) : true
    }

    const checkDisabledProjectType = (projectData: GetProjectResultType | null | undefined) => {
        const allowSteps = [
            constSubmittedStep.specifyAdditionalDoc,
            constSubmittedStep.specifySchedule,
            constSubmittedStep.commentary,
            constSubmittedStep.synthesis,
        ]
        let disabledCondition = true
        if (projectData?.stepID) {
            disabledCondition = !(
                allowSteps.includes(projectData?.stepID) &&
                (isUserAdmin() || isUserSecretary() || isUserChairmanOnly() || isUserViceChairman())
            )
        }
        return disabledCondition
    }

    return {
        irb,
        isUserSystemAdmin,
        isUserAdmin,
        isUserChairman,
        isUserViceChairman,
        isUserSecretary,
        isUserCommittee,
        isUserResearcher,
        isUserChairmanOnly,
        isAllowOfficerToEdit,
        isAllowDefineDirector,
        chkProjectStepViewMode,
        getTabRenderList,
        getFolderRenderList,
        isCommitteeInProject,
        chkShowUpdateDate,
        chkDisplayBTNDeleteProject,
        checkDisabledProjectReviewer,
        checkSaveDraft,
        checkDisabledProjectType,
        checkCanUpdateDocument,
    }
}
export default useCheckPermission
